<template>

    <ubi-panel>
        <el-dialog
                :title="$t('posts.edit.legalNotices.dialogDeleteTitle')"
                :visible.sync="modalDeleteMentionlegale"
                width="30%">
            <span>{{ $t("posts.edit.legalNotices.dialogDeleteText") }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalDeleteMentionlegale = false">{{ $t("posts.edit.legalNotices.dialogButtonCancel") }}</el-button>
                <el-button type="primary" @click="deleteMentions(selectedMention.id)">{{ $t("posts.edit.legalNotices.dialogButtonConfirm") }}</el-button>
              </span>
        </el-dialog>
        <el-dialog v-if="selectedMention"
                :title="$t('posts.edit.legalNotices.dialogUpdateTitle')"
                :visible.sync="modalUpdateMentionlegale"
                width="50%">
            <el-form-item :label="$t('posts.edit.legalNotices.dialogUpdateNoticesTitle')">
                <el-input v-model="selectedMention.titre"></el-input>
            </el-form-item>
            <el-form-item :label="$t('posts.edit.legalNotices.dialogUpdateNoticesText')">
                <el-input type="textarea" v-model="selectedMention.texte"></el-input>
            </el-form-item>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalUpdateMentionlegale = false">{{ $t("posts.edit.legalNotices.dialogButtonCancel") }}</el-button>
                <el-button type="primary" @click="utiliserMentionsLegalesExistante">{{ $t("posts.edit.legalNotices.dialogButtonUpdateOnlyForThisAd") }}</el-button>
                <el-button type="primary" @click="update_mention_legale">{{ $t("posts.edit.legalNotices.dialogButtonUpdateModel") }}</el-button>
              </span>
        </el-dialog>
        <el-container>
            <el-aside width="25%"><h3>{{ $t("posts.edit.legalNotices.title") }}</h3>
                <p class="text-justify">{{ $t("posts.edit.legalNotices.description") }}</p></el-aside>
            <el-main>
                <el-row>
                    <el-col :md="14">
                        <el-form-item prop="mentions_legales" :label="$t('posts.edit.legalNotices.chooseModel')">
                            <el-select
                                    v-model="selectedMentionId"
                                    clearable
                                    @change="selectMention"
                                    :placeholder="$t('posts.edit.legalNotices.chooseModelPlaceholder')"
                            >

                                <el-option
                                        :key="mention_legale.id"
                                        :label="mention_legale.titre"
                                        :value="mention_legale.id"
                                        v-for="mention_legale in mentionsLegales"
                                />

                            </el-select>

                        </el-form-item>
                    </el-col>
                    <el-col :md="10" style="padding-left: 10px; padding-top: 6px">
                        <br>
                        <el-button type="warning" icon="pencil" @click="displayModalUpdate"></el-button>
                        <el-button type="danger"icon="trash" @click="displayModalDelete"></el-button>
                        <el-button type="primary" @click="utiliserMentionsLegalesExistante">
                            {{ $t("posts.edit.legalNotices.buttonUse") }}
                        </el-button>
                    </el-col>
                </el-row>
                <el-row v-if="selectedMention">
                    <el-col>
                      <p><strong>{{ $t("posts.edit.legalNotices.selectedNoticesText") }} :</strong> {{selectedMention.texte}}</p>
                    </el-col>
                </el-row>
                <hr>
                <el-row>
                    <el-col>
                        <p>{{ $t("posts.edit.legalNotices.orCreateNoticesText") }}</p>
                        <el-form-item
                                :label="$t('posts.edit.legalNotices.newNoticesTitle')"
                                prop="titre_mention_legale">
                            <el-input v-model="titre_mention_legale"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item
                                :label="$t('posts.edit.legalNotices.newNoticesText')"
                                prop="texte_mention_legale">
                            <el-input v-model="texte_mention_legale" type="textarea"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-button @click="utiliserNouvelleMentions" type="warning">
                            {{ $t("posts.edit.legalNotices.buttonUse") }}
                        </el-button>
                        <span>&nbsp;</span>
                        <el-tooltip placement="top-start"
                                    :content="$t('posts.edit.legalNotices.tooltipUse')">
                            <em class="el-icon-question"></em>
                        </el-tooltip>
                        <span>&nbsp;</span>
                        <span>&nbsp;</span>
                        <span>&nbsp;</span>
                        <el-button @click="enregistrer_mention_legale" type="primary">
                            {{ $t("posts.edit.legalNotices.buttonSave") }}
                        </el-button>

                        <span>&nbsp;</span>
                        <el-tooltip placement="top-start"
                                    :content="$t('posts.edit.legalNotices.tooltipSave')">
                            <em class="el-icon-question"></em>
                        </el-tooltip>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>
    </ubi-panel>
</template>

<script>
import { fetchMentionsLegales, saveMentionLegale, deleteMentionsLegales, updateMentionLegale } from '../../../../services/posts'
import UbiPanel from '../../../../components/Panel'
export default {
  name: 'PostFormMentionsLegalesSelect',
  components: { UbiPanel },
  props: ['post'],
  data () {
    return {
      mentionsLegales: null,
      mentionsCall: null,
      texte_mention_legale: null,
      titre_mention_legale: null,
      modalDeleteMentionlegale: false,
      modalUpdateMentionlegale: false,
      selectedMention: null,
      selectedMentionId: null,
      oldMentionsText: null
    }
  },
  beforeMount () {
    this.getMentionsLegales()
  },
  methods: {
    async getMentionsLegales () {
      this.mentionsCall = await fetchMentionsLegales()
      if (this.mentionsCall.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      this.mentionsLegales = this.mentionsCall.list
    },
    selectMention () {
      this.mentionsLegales.forEach(row => {
        if (row.id == this.selectedMentionId) {
          this.selectedMention = row
        }
      })
    },
    async enregistrer_mention_legale () {
      if (this.texte_mention_legale != null) {
        const newMentionLegale = await saveMentionLegale(this.titre_mention_legale, this.texte_mention_legale)
        if (newMentionLegale.type == 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
          this.loading = false
          return false
        }
        this.$message({
          message: this.$t('posts.edit.legalNotices.messageSuccess'),
          type: 'success',
          duration: 10000
        })
        this.getMentionsLegales()
        if (this.oldMentionsText != null) {
          this.post.texte = this.post.texte.replace(this.oldMentionsText, '')
        }
        this.post.texte = this.post.texte + '\r\n\r\n' + this.texte_mention_legale
        this.oldMentionsText = '\r\n\r\n' + this.texte_mention_legale
        this.texte_mention_legale = null
        this.titre_mention_legale = null
      }
    },
    displayModalDelete () {
      this.modalDeleteMentionlegale = true
    },
    displayModalUpdate () {
      this.modalUpdateMentionlegale = true
    },
    async deleteMentions (id) {
      const response = await deleteMentionsLegales(id)
      if (response.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      if (response.status == '204') {
        this.$message({
          message: this.$t('posts.edit.legalNotices.messageDeleteSuccess'),
          type: 'success',
          duration: 10000,
          showClose: true
        })
      } else {
        this.$message({
          message: this.$t('posts.edit.legalNotices.messageDeleteError'),
          type: 'error',
          duration: 10000,
          showClose: true
        })
      }
      this.modalDeleteMentionlegale = false
      this.getMentionsLegales()
    },
    utiliserMentionsLegalesExistante () {
      if (this.selectedMention) {
        if (this.oldMentionsText != null) {
          this.post.texte = this.post.texte.replace(this.oldMentionsText, '')
        }
        this.post.texte = this.post.texte + '\r\n\r\n' + this.selectedMention.texte
        this.oldMentionsText = '\r\n\r\n' + this.selectedMention.texte
        this.$message({
          message: this.$t('posts.edit.legalNotices.messageSuccess'),
          type: 'success',
          duration: 10000,
          showClose: true
        })
      } else {
        this.$message({
          message: this.$t('posts.edit.legalNotices.messageEmptySelection'),
          type: 'error',
          duration: 10000,
          showClose: true
        })
      }
      this.modalUpdateMentionlegale = false
    },
    utiliserNouvelleMentions () {
      if (this.texte_mention_legale != null) {
        if (this.oldMentionsText != null) {
          this.post.texte = this.post.texte.replace(this.oldMentionsText, '')
        }
        this.post.texte = this.post.texte + '\r\n\r\n' + this.texte_mention_legale
        this.oldMentionsText = '\r\n\r\n' + this.texte_mention_legale
        this.$message({
          message: this.$t('posts.edit.legalNotices.messageSuccess'),
          type: 'success',
          duration: 10000,
          showClose: true
        })
      }
    },
    async update_mention_legale () {
      const response = await updateMentionLegale(this.selectedMention.id, this.selectedMention.titre, this.selectedMention.texte)
      if (response.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      if (response.status != '200') {
        this.$message({
          message: this.$t('posts.edit.legalNotices.messageUpdateError'),
          type: 'error',
          duration: 10000,
          showClose: true
        })
      } else {
        if (this.oldMentionsText != null) {
          this.post.texte = this.post.texte.replace(this.oldMentionsText, '')
        }
        this.post.texte = this.post.texte + '\r\n\r\n' + this.selectedMention.texte
        this.oldMentionsText = '\r\n\r\n' + this.selectedMention.texte
        this.$message({
          message: this.$t('posts.edit.legalNotices.messageSuccess'),
          type: 'success',
          duration: 10000,
          showClose: true
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
